/**
 * Created by slava on 5/8/17.
 */

// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line prefer-const
let resolutionScale = 1;

cleverapps.UI = {
    stableKeys: [
        "SKIP_RESOLUTION",
        "originalSize",
        "descent",
        "verticalAlignment",
        "opacity",
        "color",
        "scale9",
        "parent",
        "scale",
        "minScale",
        "maxScale",
        "iconScale",
        "rotation",
        "baseScale",
        "zoomScale",
        "mobileScale",
        "innerScale",
        "squareScale",
        "verticalScale",
        "zoom",
        "scaleX",
        "scaleY",
        "anchorX",
        "anchorY",
        "anchorPoint",
        "zIndex",
        "zOrder",
        "SIDEBAR_WIDTH",
        "MIN_SIDEBAR_X",
        "duration",
        "delay",
        "idleDelay",
        "type",
        "hideDirection",
        "number",
        "dialogueStages",
        "skew",
        "anchor",
        "factorX",
        "factorY",
        "smallMargin",
        "threshold",
        "timeScale",
        "timeout",
        "fadeIn",
        "columns",
        "align",
        "patternSize",
        "tilesInRow",
        "windowPadding"
    ],

    needUpdateSizes: function (object, i, value) {
        if (value instanceof cc.Color) {
            return false;
        }
        if (value instanceof cc.VirtualResource) {
            return false;
        }
        if (i === "direction" && typeof value !== "object") {
            return false;
        }

        if (cleverapps.UI.stableKeys.indexOf(i) >= 0) {
            return false;
        }

        return true;
    },

    scaleSizes: function (objects, scale) {
        const updated = [];

        const update = function (object) {
            if (object.isUpdated) {
                return;
            }
            object.isUpdated = true;
            updated.push(object);

            for (const i in object) {
                const value = object[i];

                if (typeof value === "number") {
                    if (Array.isArray(object)) {
                        continue;
                    }
                    if (cleverapps.UI.needUpdateSizes(object, i, value)) {
                        object[i] *= scale;
                        // if (i === "size")
                        object[i] = Math.round(object[i]);
                    }
                } else if (typeof value === "object") {
                    if (!cleverapps.UI.needUpdateSizes(object, i, value)) {
                        // console.log('Skip: ' + i);
                    } else {
                        update(value);
                    }
                }
            }
        };

        objects.forEach(update);

        updated.forEach((object) => {
            delete object.isUpdated;
        });
    },

    scaleStyles: function (object) {
        cleverapps.UI.scaleSizes([object], resolutionScale);
        return object;
    },

    updateSizes: function (resolutionScale) {
        if (cleverapps.styles.isUpdated) {
            return;
        }

        const objects = [cleverapps.styles, cleverapps.UI.ImageFont.listFonts()];

        Object.values(Forces).forEach((force) => {
            force.style && objects.push(force.style);
            force.finger && objects.push(force.finger);
        });

        cleverapps.UI.scaleSizes(objects, resolutionScale);

        cleverapps.styles.isUpdated = true;
    },

    HORIZONTAL: 0,
    VERTICAL: 1,

    DOCK_RIGHT: 1,
    DOCK_LEFT: 2,
    DOCK_BOTTOM: 4,
    DOCK_TOP: 8,

    /**
     * @param list
     * @param options: margin, direction, offset
     * @returns total Height or Width
     */
    arrangeWithMargins: function (list, options) {
        const margin = (Array.isArray(options.margin) ? options.margin[cleverapps.resolution.mode] : options.margin) || 0;
        let total = options.offset || 0;

        const iterator = options.iterator || function (object, x, y) {
            object.setPosition(x, y);
        };

        const reverseOrder = options.direction === cleverapps.UI.VERTICAL ? !options.reversed : options.reversed;
        list.forEach((object, id) => {
            if (options.direction === undefined || reverseOrder) {
                object = list[list.length - 1 - id];
            }

            const scaleX = object.baseScaleX || object.baseScale || object.scaleX;
            const scaleY = object.baseScaleY || object.baseScale || object.scaleY;

            if (options.direction === cleverapps.UI.HORIZONTAL) {
                iterator(object, total + object.width * Math.abs(scaleX) * object.anchorX, object.y);
                total += object.width * Math.abs(scaleX);
            } else {
                iterator(object, object.x, total + object.height * Math.abs(scaleY) * object.anchorY);
                total += object.height * Math.abs(scaleY);
            }
            total += margin;
        });

        return total - margin;
    },

    calculateContentSize: function (node) {
        const children = node.children;
        if (children.length === 0) {
            return cc.size(0, 0);
        }

        let minY, maxY, minX, maxX;

        for (let i = 0; i < children.length; i++) {
            const child = children[i];

            const scaleX = child.baseScaleX || child.baseScale || child.scaleX;
            const scaleY = child.baseScaleY || child.baseScale || child.scaleY;

            const bottom = child.y - child.height * scaleY * child.anchorY;
            const top = bottom + child.height * scaleY;

            if (minY === undefined || minY > bottom) {
                minY = bottom;
            }

            if (maxY === undefined || maxY < top) {
                maxY = top;
            }

            const left = child.x - child.width * scaleX * child.anchorX;
            const right = left + child.width * scaleX;

            if (minX === undefined || minX > left) {
                minX = left;
            }

            if (maxX === undefined || maxX < right) {
                maxX = right;
            }
        }

        return cc.size(Math.round(maxX - minX), Math.round(maxY - minY));
    },

    fitToBox: function (view, options) {
        const signX = view.scaleX < 0 ? -1 : 1;
        const signY = view.scaleY < 0 ? -1 : 1;

        // Stretch mode: scale X and Y independently so the view fills width x height exactly
        // (aspect ratio not preserved). A missing dimension keeps that axis unscaled. Used for
        // backgrounds that must fill a fixed box, e.g. a spine title bg behaving like a scale9.
        if (options.stretch) {
            view.setScaleX(signX * (options.width || view.width) / view.width);
            view.setScaleY(signY * (options.height || view.height) / view.height);
            return;
        }

        const maxScale = options.maxScale || 1;
        const minScale = options.minScale || 0;
        const scaleX = signX * options.width / view.width || maxScale;
        const scaleY = signY * options.height / view.height || maxScale;

        const scale = Math.max(minScale, Math.min(scaleX, scaleY, maxScale));
        view.setScaleX(scale * signX);
        view.setScaleY(scale * signY);
    },

    calcBoundaries: function (overlappingList, options) {
        options = options || {};
        const scene = cleverapps.Scenes.GetRunningScene();
        const sceneSize = cleverapps.resolution.getSceneSize();

        const c = options.lovesPosition || options.centerPoint || scene.convertToWorldSpace(cc.p(sceneSize.width / 2, sceneSize.height / 2));

        const boxes = overlappingList.map((node) => {
            const box = node.getGlobalBoundingBox();

            if (cleverapps.config.debugMode) {
                if (box.x < c.x && c.x < box.x + box.width && box.y < c.y && c.y < box.y + box.height) {
                    throw "Incorrect center point! Should be outside all boxes.";
                }
            }

            return box;
        });

        let squareEdge = Math.min(c.x, sceneSize.width - c.x, c.y, sceneSize.height - c.y);

        boxes.forEach((box) => {
            const nearest = cc.nearestToRect(box, c);
            const boxSquareEdge = Math.max(
                Math.abs(nearest.x - c.x),
                Math.abs(nearest.y - c.y)
            );

            squareEdge = Math.min(squareEdge, boxSquareEdge);
        });

        const avail = cc.rect(c.x - squareEdge, c.y - squareEdge, 2 * squareEdge, 2 * squareEdge);

        const order = (cleverapps.resolution.mode === cleverapps.WideMode.VERTICAL) ? ["y", "x"] : ["x", "y"];

        const eps = 1e-6;

        const center = cc.p(avail.x + avail.width / 2, avail.y + avail.height / 2);

        const bgSize = cleverapps.resolution.getBgSize();
        const safePadding = cleverapps.resolution.getSafePadding();

        order.forEach((coordinate) => {
            const dimension = coordinate === "x" ? "width" : "height";

            if (coordinate === "x") {
                avail.x = safePadding.left;
                avail.width = bgSize.width - safePadding.left - safePadding.right;
            } else {
                avail.y = safePadding.bottom;
                avail.height = bgSize.height - safePadding.bottom - safePadding.top;
            }

            boxes.forEach((box) => {
                if (!cc.rectIntersectsRect(avail, box)) {
                    return;
                }

                const intersection = cc.rectIntersection(avail, box);
                if (intersection.width < eps || intersection.height < eps) {
                    return;
                }

                if (box[coordinate] < center[coordinate]) {
                    avail[dimension] = (avail[coordinate] + avail[dimension]) - (box[coordinate] + box[dimension]);
                    avail[coordinate] = box[coordinate] + box[dimension];
                } else if (box[coordinate] > center[coordinate]) {
                    avail[dimension] = box[coordinate] - avail[coordinate];
                }
            });

            if (coordinate === "x") {
                const width = Math.min(center.x - avail.x, avail.x + avail.width - center.x);
                avail.x = center.x - width;
                avail.width = width * 2;
            }
        });

        if (isNaN(avail.x) || isNaN(avail.y) || isNaN(avail.width) || isNaN(avail.height)) {
            cleverapps.throwAsync(`NaN available area${JSON.stringify({
                center,
                boxes,
                sceneSize,
                bgSize,
                avail
            })}`);
        }

        return avail;
    },

    inflateToBoundaries: function (view, overlappingList, options) {
        let availableRect = cleverapps.UI.calcBoundaries(overlappingList, options);

        if (options.padding) {
            availableRect = cc.rectSubPadding(availableRect, cc.padding(options.padding));
        }

        view.setScale(1);
        let newScale;
        if (availableRect.width === 0 || availableRect.height === 0) {
            newScale = 0;
        } else {
            newScale = Math.min(availableRect.width / view.width, availableRect.height / view.height, options.maxScale || 100);
        }
        let newPosition = cc.rectGetCenter(availableRect);

        if (options.lovesPosition) {
            newPosition = cc.nearestToRect(
                cc.rectSubPadding(availableRect, cc.padding(view.height * newScale / 2, view.width * newScale / 2)),
                options.lovesPosition
            );
        }

        newPosition = view.parent.convertToNodeSpace(newPosition);

        if (isNaN(newPosition.x) || isNaN(newPosition.y) || isNaN(newScale)) {
            if (cleverapps.config.debugMode) {
                console.log({
                    newPosition,
                    newScale,
                    availableRect,
                    width: view.width,
                    height: view.height,
                    sceneSize: cleverapps.resolution.getSceneSize(),
                    bgSize: cleverapps.resolution.getBgSize()
                });
                throw "NaN inflate scale";
            }
            cleverapps.throwAsync(`NaN inflate scale${JSON.stringify({
                newPosition,
                newScale,
                availableRect,
                width: view.width,
                height: view.height,
                sceneSize: cleverapps.resolution.getSceneSize(),
                bgSize: cleverapps.resolution.getBgSize()
            })}`);
            return;
        }

        view.setScale(newScale);
        view.setPosition(newPosition);
    },

    fitToBounds: function (positions, size, bounds, offset) {
        positions.map((position) => {
            if (position.x < bounds.x) {
                position.x = bounds.x + offset.x;
            }

            if (position.x + size.width > bounds.width) {
                position.x = bounds.width - size.width - offset.x;
            }

            if (position.y < bounds.y) {
                position.y = bounds.y + offset.y;
            }

            if (position.y + size.height > bounds.height) {
                position.y = bounds.height - size.height - offset.y;
            }

            return position;
        });
        return positions;
    },

    findPositionsAroundRect: function (targetRect, avoidedRect, bounds, offset) {
        offset = offset || { x: 10 * resolutionScale, y: 10 * resolutionScale };
        const positions = [];

        positions.push({
            x: avoidedRect.x - targetRect.width - offset.x,
            y: avoidedRect.y + avoidedRect.height / 2 - targetRect.height / 2
        });

        positions.push({
            x: avoidedRect.x + avoidedRect.width + offset.x,
            y: avoidedRect.y + avoidedRect.height / 2 - targetRect.height / 2
        });

        positions.push({
            x: avoidedRect.x + avoidedRect.width / 2 - targetRect.width / 2,
            y: avoidedRect.y - targetRect.height - offset.y
        });

        positions.push({
            x: avoidedRect.x + avoidedRect.width / 2 - targetRect.width / 2,
            y: avoidedRect.y + avoidedRect.height + offset.y
        });

        return this.fitToBounds(positions, targetRect, bounds, offset);
    },

    rectsIntersection: function (targetRect, rects) {
        for (let i = 0; i < rects.length; i++) {
            const rect = rects[i];
            const intersection = cc.rectIntersectsRect(targetRect, rect);
            if (intersection) {
                return true;
            }
        }
        return false;
    },

    checkPositions: function (preferredPositions, rects, targetRect) {
        for (let i = 0; i < preferredPositions.length; i++) {
            const position = preferredPositions[i];

            targetRect.x = position.x;
            targetRect.y = position.y;

            const isIntersectionWithNodes = this.rectsIntersection(targetRect, rects);

            if (!isIntersectionWithNodes) {
                return position;
            }
        }
    },

    findPosition: function (view, options) {
        let preferredPositions = options.preferredPositions;
        const avoidNodes = options.avoidNodes;

        const convertPositionToNodeSpace = function (newPosition) {
            return Object.assign(view.parent.convertToNodeSpace({
                x: newPosition.x + view.width * view.anchorX,
                y: newPosition.y + view.height * view.anchorY
            }), { preferred: newPosition.preferred });
        };

        preferredPositions = preferredPositions.map((preferred) => {
            const position = view.positionFromAlignment(preferred);
            return Object.assign(view.parent.convertToWorldSpace({
                x: position.x - view.width * (1 - view.anchorX),
                y: position.y - view.height * (1 - view.anchorY)
            }), { preferred });
        });

        const rectsOfAvoidedNodes = avoidNodes.map((node) => node.getGlobalBoundingBox());

        const targetRect = view.getGlobalBoundingBox();
        const sceneSize = cleverapps.resolution.getSceneSize();
        const safePadding = cleverapps.resolution.getSafePadding();

        rectsOfAvoidedNodes.forEach((rect) => {
            preferredPositions = preferredPositions.concat(this.findPositionsAroundRect(targetRect, rect, {
                x: safePadding.left, y: safePadding.bottom, width: sceneSize.width, height: sceneSize.height
            }, options.offset));
        });

        const newPosition = this.checkPositions(preferredPositions, rectsOfAvoidedNodes, targetRect);
        if (newPosition) {
            return convertPositionToNodeSpace(newPosition);
        }
    },

    findPlaceForRect: function (targetRect, availableRect, avoidRects = []) {
        targetRect = cc.rectClampToRect(targetRect, availableRect);

        for (let limit = 5; limit > 0; --limit) {
            const repulsion = cc.p(0, 0);

            avoidRects.forEach((avoidRect) => {
                const intersection = cc.rectIntersection(targetRect, avoidRect);
                if (intersection.width <= 0 || intersection.height <= 0) {
                    return;
                }

                const availableCenter = cc.rectGetCenter(availableRect);
                const targetCenter = cc.rectGetCenter(intersection);

                const deltaX = targetCenter.x < availableCenter.x
                    ? avoidRect.x + avoidRect.width - targetRect.x
                    : avoidRect.x - targetRect.x - targetRect.width;

                const deltaY = targetCenter.y < availableCenter.y
                    ? avoidRect.y + avoidRect.height - targetRect.y
                    : avoidRect.y - targetRect.y - targetRect.height;

                if (deltaX * deltaX < deltaY * deltaY) {
                    if (deltaX * deltaX > repulsion.x * repulsion.x + repulsion.y * repulsion.y) {
                        repulsion.x = deltaX;
                        repulsion.y = 0;
                    }
                } else if (deltaY * deltaY > repulsion.x * repulsion.x + repulsion.y * repulsion.y) {
                    repulsion.x = 0;
                    repulsion.y = deltaY;
                }
            });

            if (repulsion.x === 0 && repulsion.y === 0) {
                break;
            }

            targetRect.x += repulsion.x;
            targetRect.y += repulsion.y;
        }

        return targetRect;
    },

    getFontName: function (font) {
        if (font === undefined) {
            font = bundles.ui.urls.basefont_ttf;
        }

        if (engine === "creator") {
            return cc.LabelTTF.getCreatorFontName(font.srcs[0]);
        }

        return font.name;
    },

    isRTL: function () {
        return cleverapps.settings.language === "ar";
    },

    generateImageText: function (text, font, params, deprecated) {
        if (deprecated && cleverapps.config.debugMode) {
            throw "deprecated";
        }

        params = params || {};

        if (cleverapps.config.debugMode && !cleverapps.UI.ImageFont.IsApplicable(font, text)) {
            console.log(font);
            throw `Not applicable image font: ${text}`;
        }
        return new cleverapps.UI.ImageFont(text, font, params);
    },

    generateOnlyText: function (text, font) {
        const content = new cleverapps.UI.LabelTTF("", cleverapps.UI.getFontName(font.font));
        content.setString(text);
        content.setFont(font);

        return content;
    },

    /*
     * @deprecated
     */
    generateTTFText: function (text, font) {
        let content;

        if (cleverapps.UI.ImageFont.IsApplicable(font, text)) {
            content = new cleverapps.UI.ImageFont(text, font);
        } else {
            content = new cleverapps.UI.LabelTTF("", cleverapps.UI.getFontName(font.font));
            content.setString(text);
            content.setFont(font);
        }

        return content;
    },

    drawUnderline: function (textNode, position) {
        const underline = new cc.Scale9Sprite(bundles.ui.frames.underline_png);
        underline.setContentSize2(textNode.width, position && position.height ? position.height : 1);
        underline.setAlignment(position || { x: textNode.x + textNode.width / 10, y: textNode.y - textNode.height / 10 });
        underline.setAnchorPoint(0.5, 0.5);
        underline.setColor(textNode._getFillStyle() || cc.color.BLACK);
        return underline;
    },

    CheckBox: cc.Node.extend({
        ctor: function (options) {
            this._super();

            options = options || {};
            options.styles = options.styles || {};
            this.options = options;

            this.onChangeCallback = options.onChange || function () {};

            this.selected = false;

            const items = [];

            const checkBox = this.createCheckBox();
            items.push(checkBox);

            if (options.label) {
                this.createLabel();
                items.push(this.label);
            }

            const styles = this.getStyles();

            const layout = new cleverapps.Layout(items, {
                margin: styles.margin,
                padding: styles.padding,
                direction: options.direction !== undefined ? options.direction : cleverapps.UI.HORIZONTAL,
                reversed: options.direction === cleverapps.UI.VERTICAL
            });
            this.addChild(layout);

            if (this.label) {
                this.label.y += styles.label.offsetY;
            }

            this.setAnchorPoint(0.5, 0.5);
            this.setContentSize2(layout.getContentSize());

            layout.setAlignment(this.width / 2, this.height / 2);

            cleverapps.UI.applyHover(this);

            if (this.options.label && this.options.label.clickable) {
                cleverapps.UI.onClick(this, this.onClick.bind(this));
            } else {
                cleverapps.UI.onClick(checkBox, this.onClick.bind(this));
            }

            this.setSelected(this.options.isSelected);
        },

        createCheckBox: function () {
            const checkBox = new cc.Sprite(this.options.bgImage || bundles.checkbox.frames.checkbox_background_png);

            this.icon = new cc.Sprite(this.options.checkImage || bundles.checkbox.frames.check_mark_png);
            checkBox.addChild(this.icon);
            this.icon.setAlignment(checkBox.width / 2, checkBox.height / 2);
            this.icon.setVisible(false);

            return checkBox;
        },

        createLabel: function () {
            // eslint-disable-next-line no-restricted-syntax
            this.label = cleverapps.UI.generateTTFText(this.options.label.text, this.options.label.font || cleverapps.styles.FONTS.WINDOW_TEXT);
        },

        onClick: function () {
            this.setSelected(!this.isSelected());

            cleverapps.effects.fire("ui.button.click");
        },

        isSelected: function () {
            return this.selected;
        },

        setSelected: function (selected) {
            if (this.selected === selected) {
                return;
            }

            this.selected = selected;

            this.icon.setVisible(selected);

            this.onChangeCallback(this.selected);
        },

        getStyles: function () {
            if (!this.styles) {
                this.styles = cleverapps.overrideStyles(cleverapps.styles.UI.CheckBox, this.options.styles, true);
            }
            return this.styles;
        }
    }),

    wrap: function (node, options) {
        options = options || {};

        const boundsChildren = options.children || node.children;
        if (boundsChildren.length === 0) {
            node.setContentSize(0, 0);

            return node;
        }

        let minY, maxY, minX, maxX;

        for (let i = 0; i < boundsChildren.length; i++) {
            const child = boundsChildren[i];

            let scaleX = child.baseScaleX || child.baseScale || child.scaleX;
            let scaleY = child.baseScaleY || child.baseScale || child.scaleY;

            let height = child.height;
            let width = child.width;

            if (options.considerRotation) {
                height = child.getBoundingBox().height;
                width = child.getBoundingBox().width;
                scaleX = 1;
                scaleY = 1;
            }

            const bottom = child.y - height * scaleY * child.anchorY;
            const top = bottom + height * scaleY;

            if (minY === undefined || minY > bottom) {
                minY = bottom;
            }

            if (maxY === undefined || maxY < top) {
                maxY = top;
            }

            const left = child.x - width * scaleX * child.anchorX;
            const right = left + width * scaleX;

            if (minX === undefined || minX > left) {
                minX = left;
            }

            if (maxX === undefined || maxX < right) {
                maxX = right;
            }
        }

        node.children.forEach((child) => {
            ComponentMap.detach(child, AlignmentComponent);
            child.x -= minX;
            child.y -= minY;
        });
        node.setContentSize2(maxX - minX, maxY - minY);

        return node;
    },

    wrapWithPadding: function (node, padding, noNewNode) {
        padding = cc.padding(padding);

        if (noNewNode) {
            node.children.forEach((child) => {
                child.setAlignment(child.x + padding.left, child.y + padding.bottom);
            });
            node.width += padding.left + padding.right;
            node.height += padding.top + padding.bottom;
            return node;
        }

        const res = new cc.Node();
        res.addChild(node);

        res.setContentSize2(node.width * node.scaleX + padding.left + padding.right, node.height * node.scaleY + padding.top + padding.bottom);
        res.setAnchorPoint(0.5, 0.5);
        node.setPosition(padding.left + node.width * node.scaleX / 2, padding.bottom + node.height * node.scaleY / 2);

        return res;
    },

    setDimensions: function (node, options) {
        const width = options.width || node.width * node.scaleX;
        const height = options.height || node.height * node.scaleY;

        cleverapps.UI.fitToBox(node, {
            width,
            height
        });

        const deltaX = Math.max(0, width - node.width * node.scaleX);
        const deltaY = Math.max(0, height - node.height * node.scaleY);

        if (deltaX || deltaY) {
            cleverapps.UI.wrapWithPadding(node, {
                x: deltaX / 2 / node.scaleX,
                y: deltaY / 2 / node.scaleY
            }, true);
        }
    },

    onDrag: function (target, options) {
        options = options || {};
        return cleverapps.pointerManager.create(target, options);
    },

    onPressed: function (target, callback, options) {
        options = options || {};
        options.onPressed = callback;
        return cleverapps.pointerManager.create(target, options);
    },

    onClick: function (target, callback, options) {
        options = options || {};
        options.onClick = callback;
        return cleverapps.pointerManager.create(target, options);
    },

    applyHover: function (target, options) {
        options = options || {};
        options.hover = true;
        return cleverapps.pointerManager.create(target, options);
    },

    convertToGrayShape: function (node, restore) {
        node.setColor(cleverapps.styles.COLORS.BLACK);
        node.setOpacity(100);

        if (restore) {
            node.setColor(cleverapps.styles.COLORS.WHITE);
            node.setOpacity(255);
        }
    },

    convertToGrayScale: function (node, restore) {
        if (typeof gl === "undefined") {
            return;
        }
        if (node.spine) {
            node = node.spine;
        }

        if (restore) {
            if (node.normalShader) {
                node.setShaderProgram(node.normalShader);
            } else {
                node.opacity = 255;
            }
        } else if (cc.shaderCache && cleverapps.Shaders && cc.shaderCache._programs[cleverapps.Shaders.GRAYSCALE_SPRITE_KEY]) {
            if (!node.normalShader) {
                node.normalShader = node.getShaderProgram();
            }
            node.setShaderProgram(cc.shaderCache.getProgram(cleverapps.Shaders.GRAYSCALE_SPRITE_KEY));
        } else {
            node.opacity = 150;
        }
    },

    outlineSprite: function (node, restore) {
        if (typeof gl === "undefined") {
            return;
        }
        if (node.spine) {
            node = node.spine;
        }

        if (restore) {
            if (node.normalShader) {
                node.setShaderProgram(node.normalShader);
            }
        } else if (cc.shaderCache && cleverapps.Shaders && cc.shaderCache._programs[cleverapps.Shaders.OUTLINE_KEY]) {
            if (!node.normalShader) {
                node.normalShader = node.getShaderProgram();
            }
            node.setShaderProgram(cc.shaderCache.getProgram(cleverapps.Shaders.OUTLINE_KEY));
        }
    },

    _setShaderUpdate: function (node, programKey, shaderUpdate) {
        if (node._superUpdate) {
            node.update = node._superUpdate.bind(node);
            delete node._superUpdate;

            if (node.normalShader) {
                node.setShaderProgram(node.normalShader);
            }
        } else if (cleverapps.Shaders && cleverapps.Shaders.getProgram(programKey)) {
            if (!node.normalShader) {
                node.normalShader = node.getShaderProgram();
            }

            node.setShaderProgram(cleverapps.Shaders.getProgram(programKey));
            const shader = node.getShaderProgram();

            node._superUpdate = node.update;
            node.scheduleUpdate();
            node.update = function (dt) {
                shaderUpdate(dt, shader);
            };
        }
    },

    toggleFlickering: function (node, options) {
        if (typeof gl === "undefined") {
            return;
        }

        options = options || {};
        let flickSpeed = options.flickSpeed || 2;
        const flickPause = options.flickPause || 0;
        let color = options.color;
        if (!color || !Array.isArray(color) || color.length < 3) {
            color = [0.35, 0.35, 0.35];
        }

        flickSpeed *= Math.PI;

        let flickerTime = 0;
        const flickerUpdate = function (dt, flickerShader) {
            node._superUpdate(dt);

            flickerShader.use();
            flickerTime += dt;

            const timeFunction = Math.abs(Math.sin(Math.max(flickerTime - flickPause, 0) * flickSpeed));
            flickerShader.setUniformLocationWith1f("sineTime", timeFunction);
            flickerShader.setUniformLocationWith3f("flickColor", color[0], color[1], color[2]);
        };

        this._setShaderUpdate(node, cleverapps.Shaders.FLICKER_SHADER_KEY, flickerUpdate);
    },

    toggleBlur: function (node, options) {
        options = options || {};
        options.animate = options.animate || {};

        if (typeof gl === "undefined") {
            options.animate && options.animate.callback && options.animate.callback();
            return;
        }

        const blurLength = options.blurLength || 0.005;
        const strength = options.strength || 1;
        const dim = Math.max(0, Math.min(1, options.dim || 0));

        const setParams = function (curStrength, curCurtain) {
            node.blurShader.use();
            node.blurShader.setUniformLocationWith1f("u_blurOffset", blurLength);
            node.blurShader.setUniformLocationWith1f("u_blurStrength", curStrength);
            node.blurShader.setUniformLocationWith1f("u_extent", curCurtain);
            node.blurShader.setUniformLocationWith1f("u_dim", dim);
        };

        const animateAction = function (restore, callback) {
            callback = callback || function () {};
            const type = options.animate.type || cleverapps.UI.BLUR_ANIMATION.FADE;
            const blurTime = options.animate.time !== undefined ? options.animate.time : 0.2;
            const steps = options.animate.steps || 20;

            let curStrength = restore ? strength : 0;
            let curCurtain = restore ? 1 : 0;

            const strengthStep = strength / steps;
            const curtainStep = 1 / steps;

            node.blurAction = node.runAction(new cc.Sequence(
                new cc.Repeat(
                    new cc.Sequence(
                        new cc.CallFunc(() => {
                            if (type === cleverapps.UI.BLUR_ANIMATION.FADE) {
                                curStrength += restore ? -strengthStep : strengthStep;
                                setParams(curStrength, 1);
                            } else {
                                curCurtain += restore ? -curtainStep : curtainStep;
                                setParams(strength, curCurtain);
                            }
                        }),
                        new cc.DelayTime(blurTime / steps)
                    ),
                    steps
                ),
                new cc.CallFunc(callback)
            ));
            node.blurAction.whenDone = callback;
        };

        if (node.blurAction && !node.blurAction.isDone()) {
            node.stopAction(node.blurAction);
            node.blurAction.whenDone();
            delete node.blurAction;
        }

        if (node.normalShader) {
            const clear = function () {
                node.setShaderProgram(node.normalShader);
                delete node.normalShader;
                delete node.blurShader;
            };

            if (options.animate) {
                animateAction(true, () => {
                    clear();
                    options.animate.callback && options.animate.callback();
                });
            } else {
                clear();
            }
        } else if (cc.shaderCache && cleverapps.Shaders) {
            let programKey = cleverapps.Shaders.BLUR_FADE_KEY;
            if (options.animate.type === cleverapps.UI.BLUR_ANIMATION.CURTAIN) {
                programKey = options.animate.reverseCurtain ? cleverapps.Shaders.BLUR_CURTAIN_REVERSE_KEY : cleverapps.Shaders.BLUR_CURTAIN_KEY;
            }

            if (cleverapps.Shaders.getProgram(programKey)) {
                node.normalShader = node.getShaderProgram();

                node.setShaderProgram(cleverapps.Shaders.getProgram(programKey));
                node.blurShader = node.getShaderProgram();

                if (options.animate) {
                    animateAction(false, options.animate.callback);
                } else {
                    setParams(strength, 1);
                }
            }
        }
    },

    createTapAnimation: function (touch) {
        if (!cleverapps.bundleLoader.isLoaded("tap_animation")) {
            return;
        }

        const scene = cleverapps.Scenes.GetRunningScene();

        const tapAnimation = new cleverapps.Spine(bundles.tap_animation.jsons.tap_animation_json);
        tapAnimation.setLocalZOrder(10000);
        tapAnimation.setScale(cleverapps.resolution.mode === cleverapps.WideMode.HORIZONTAL ? 0.8 : 1);
        scene.addChild(tapAnimation);
        // a theme may ship several tap variants, one plays at random
        tapAnimation.setAnimation(0, PseudoRandom.GET("tap").choose(tapAnimation.listAnimations()), false);
        tapAnimation.setCompleteListenerRemove();

        const position = scene.convertTouchToNodeSpace(touch);
        tapAnimation.setPosition(position.x, position.y);

        return tapAnimation;
    },

    createSceneScreenshot: function () {
        const bgSize = cleverapps.resolution.getBgSize();
        const bgRect = cleverapps.resolution.getBgRect();
        const rt = new cc.RenderTexture(bgSize.width, bgSize.height);
        rt.setAnchorPoint(0, 0);
        rt.setPosition(0, 0);
        rt.begin();
        cleverapps.Scenes.GetRunningScene().visit();
        rt.end();

        const blurSprite = this.blurSprite = new cc.Sprite(rt.getSprite().getTexture());
        blurSprite.setAnchorPoint(0, 1);
        blurSprite.setPosition(bgRect.x, bgRect.y);
        blurSprite.setScale(1, -1);

        return blurSprite;
    },

    createPatternSprite: function (fileName, size) {
        if (size === undefined) {
            size = cleverapps.resolution.getSceneSize();
        }

        const sprite = new cc.Sprite(fileName);
        if (size.width === "auto") {
            size.width = sprite.width - 2;
        }
        if (size.height === "auto") {
            size.height = sprite.height - 2;
        }

        if (typeof gl !== "undefined" && sprite.getTexture()) {
            sprite.getTexture().setTexParameters({
                minFilter: gl.NEAREST,
                magFilter: gl.NEAREST,
                wrapS: gl.REPEAT,
                wrapT: gl.REPEAT
            });

            const rect = sprite.getTextureRect();
            rect.width = size.width;
            rect.height = size.height;
            sprite.setTextureRect(rect);
        } else if (size.width && size.height) {
            sprite.setScale(size.width / sprite.width, size.height / sprite.height);
        }
        sprite.setAlignment(size.width / 2, size.height / 2);
        return sprite;
    },

    createSprite: function (styles) {
        if (!styles) {
            return new cc.Sprite();
        }

        let image = styles && styles.image || styles;

        if (styles.scale9 !== undefined && styles.scale9 !== false) {
            const sprite = cleverapps.UI.createScale9Sprite(image, styles.scale9);
            let width, height;
            if (styles.sizes) {
                width = styles.sizes[cleverapps.resolution.mode].width;
                height = styles.sizes[cleverapps.resolution.mode].height;
            } else {
                width = styles.width;
                height = styles.height;
            }

            let rotation = styles.rotation;
            if (styles.rotations) {
                rotation = styles.rotations[cleverapps.resolution.mode];
            }

            if (rotation) {
                const tmp = height;
                height = width;
                width = tmp;

                sprite.setRotation(rotation);
            }

            sprite.setContentSize2(width, height);
            return sprite;
        }

        const spriteFrameName = image;
        image = new cc.Sprite(image);
        image.scale = styles.scale || 1;
        image.spriteFrameName = spriteFrameName;
        return image;
    },

    getScale9Rect: function (spriteFrame, type) {
        const twoPixelsAnchors = {};

        if (type === cleverapps.UI.Scale9Rect.TwoPixelXY) {
            twoPixelsAnchors.x = 0.5;
            twoPixelsAnchors.y = 0.5;
        } else if (type === cleverapps.UI.Scale9Rect.TwoPixelX) {
            twoPixelsAnchors.x = 0.5;
        } else if (type === cleverapps.UI.Scale9Rect.TwoPixelY) {
            twoPixelsAnchors.y = 0.5;
        } else if (type) {
            twoPixelsAnchors.x = type.x;
            twoPixelsAnchors.y = type.y;
        }

        if (spriteFrame instanceof VirtualResource) {
            spriteFrame = spriteFrame.resolve();
        }

        const spriteSize = spriteFrame.getOriginalSize();

        const isTwoPixelX = typeof twoPixelsAnchors.x === "number";
        const x = Math.round(isTwoPixelX ? (spriteSize.width - 2) * twoPixelsAnchors.x : spriteSize.width / 3);
        const width = Math.round(isTwoPixelX ? 2 : spriteSize.width / 3);

        const isTwoPixelY = typeof twoPixelsAnchors.y === "number";
        const y = Math.round(isTwoPixelY ? (spriteSize.height - 2) * twoPixelsAnchors.y : spriteSize.height / 3);
        const height = Math.round(isTwoPixelY ? 2 : spriteSize.height / 3);

        return cc.rect(x, y, width, height);
    },

    createScale9Sprite: function (spriteFrame, type) {
        return new cc.Scale9Sprite(spriteFrame, cleverapps.UI.getScale9Rect(spriteFrame, type));
    },

    updateScale9Sprite: function (sprite, spriteFrame, type) {
        const capInsets = cleverapps.UI.getScale9Rect(spriteFrame, type);
        sprite.setSpriteFrame(spriteFrame);
        sprite.setCapInsets(capInsets);
    },

    createAnimation: function (styles) {
        styles = styles.spine;

        const animation = new cleverapps.Spine(styles.json);
        animation.setAnimation(0, styles.openAnimation, false);

        if (styles.idleAnimation) {
            animation.setCompleteListener(() => {
                animation.setAnimation(0, styles.idleAnimation, true);
            });
        }

        return animation;
    },

    isNodeOnScene: function (node, widthPart, heightPart) {
        const scene = cleverapps.Scenes.GetRunningScene();
        const bottomLeft = scene.convertToNodeSpace(node.convertToWorldSpace(cc.p(0, 0)));
        const topRight = scene.convertToNodeSpace(node.convertToWorldSpace(cc.p(node.width, node.height)));
        const rect = cc.rect(bottomLeft.x, bottomLeft.y, topRight.x - bottomLeft.x, topRight.y - bottomLeft.y);

        widthPart = rect.width < scene.width && widthPart || 0;
        heightPart = rect.height < scene.height && heightPart || 0;

        if (rect.x + (1 - widthPart) * rect.width < 0 || rect.x + widthPart * rect.width > scene.width) {
            return false;
        }

        if (rect.y + (1 - heightPart) * rect.height < 0 || rect.y + heightPart * rect.height > scene.height) {
            return false;
        }

        return true;
    }
};

cleverapps.styles.UI = {
    Avatar: {
        x: 8,
        top: 8,
        bottom: 8
    },

    CheckBox: {
        margin: 10,
        label: {
            offsetY: 0
        }
    },

    SafeArea: {
        Vertical: {
            left: 10,
            right: 10,
            top: 5,
            bottom: 5
        },

        Horizontal: {
            left: 40,
            right: 40,
            top: 5,
            bottom: 5
        }
    }
};

cleverapps.UI.Scale9Rect = {
    Default: 0,
    TwoPixelX: 1,
    TwoPixelY: 2,
    TwoPixelXY: 3
};

cleverapps.UI.BLUR_ANIMATION = {
    "FADE": 1,
    "CURTAIN": 2
};

cleverapps.UI.findNodes = function (Class, root) {
    const nodes = [root || cleverapps.Scenes.GetRunningScene()];

    const result = [];

    let index = 0;
    while (index < nodes.length) {
        const node = nodes[index++];

        if (node instanceof Class) {
            result.push(node);
        }

        node.getChildren().forEach((child) => nodes.push(child));
    }

    return result;
};